import * as React from "react";

import "./other-orders-table.scss";

import {cs}              from "@Common/react/chain-services";
import {DataTableD1}     from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {formatMoney}     from "@Common/ui-components/language/format-money";
import {parseDate}       from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";

export const OtherOrdersTable = ({otherCopays}) => cs(
    ({}, next) => (
        <div className="other-orders-table-6xm">
            <div className="label">
                Other order(s) associated for this property
            </div>

            {next()}
        </div>
    ),
    () => DataTableD1({
        darkRows: otherCopays.length % 2 === 1 ? "odd" : "even",
        rows: otherCopays.map((copay) => ({
            columns: [
                {
                    render: () => parseDateFormat("mm/dd/yy").formatDate(parseDate(copay.dateCreated.date)),
                    sortValue: () => new Date(copay.dateCreated.date).getTime(),
                },
                {
                    render: () => copay.itemId,
                },
                {
                    render: () => copay.itemName,
                },
                {
                    render: () => formatMoney(copay.creditUsed),
                },
            ],
        })),
        columns: [
            {
                label: "DATE",
                className: "date",
                sortable: {
                    defaultDirection: "asc",
                },
            },
            {
                // width: "99%",
                // width: "100px",
                label: "ORDER ID",
                className: "order-id",
            },
            {
                width: "99%",
                // width: "100px",
                label: "ORDER NAME",
                className: "order-name",
            },
            {
                // width: "100px",
                label: "AMOUNT",
                className: "amount",
            },
        ],
    }),
);
